module.exports = __webpack_public_path__ + "static/media/TP13.ec4ea7fd.jpg";